// Generated by CoffeeScript 2.7.0
var TransformUserModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import TransformUserPopover from './transform_user_popover.js';

export default TransformUserModal = Vue.extend({
  components: {
    "modal": Modal,
    "transform-user-popover": TransformUserPopover
  },
  data: function() {
    return {
      targetUser: null,
      transformUser: null
    };
  },
  template: `<modal title='转移用户' extendClass="transform-user-modal" ref="modal">
  <div class="modal-body">
    <div class="field-list-two-item">
      <div class="form-field">
        <div class="form-field-head">
          <div class="form-field-title">选择待转移的用户</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <transform-user-popover :initialSelectedUser="transformUser"
                                    userType="transform-user"
                                    @valueChanged="valueChangedFunc" />
          </div>
          <div class="message">请选择待转移的用户</div>
        </div>
      </div>
      <div class="form-field">
        <div class="form-field-head">
          <div class="form-field-title">选择转移的目标用户</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <transform-user-popover :initialSelectedUser="targetUser"
                                    userType="target-user"
                                    @valueChanged="valueChangedFunc" />
          </div>
          <div class="message">请选择转移的目标用户</div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer" slot="footer">
    <button class="outlined btn-default" @click='modalCancel'>取消</button>
    <button @click='doRequest'>确定</button>
  </div>
</modal>`,
  methods: {
    modalCancel: function() {
      return this.$refs.modal.close();
    },
    doRequest: function() {
      if (!this.transformUser || !this.targetUser) {
        return;
      }
      return Skylark.Libs.Ajax.put(Skylark.Helpers.UrlHelper.adminUrlFor(`/settings/users/${this.transformUser.id}/transfer/${this.targetUser.id}`), {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: () => {
          Skylark.Bridge.newAlertify('操作成功', {
            type: 'success'
          });
          return this.modalCancel();
        },
        error: function() {
          return Skylark.Bridge.newAlertify('操作失败，请重试', {
            type: 'error'
          });
        }
      });
    },
    valueChangedFunc: function(user, type) {
      if (type === "transform-user") {
        return this.transformUser = user;
      } else {
        return this.targetUser = user;
      }
    }
  }
});
